module.exports = __webpack_public_path__ + "media/SetB_L6_A.e288f8bd.mp3";